export default () => ({
	open: false,
	data: null,
	product_title: '',
	product_url: '',
	media_url: '',
	media_alt: '',
	selected_variant: {
		id: '',
		title: '',
		price: '',
		compare_at_price: '',
	},
	variants: [],

	get price() {
		const price = (this.selected_variant?.price / 100)
			.toFixed(2)
			.replace('.', ',')
			.toString()
			.concat(' ')
			.concat(Shopify.currency.active);
		return price;
	},

	get comparePrice() {
		let compareAtPrice = '';
		if (
			this.selected_variant?.compare_at_price &&
			this.selected_variant?.compare_at_price > this.selected_variant?.price
		) {
			compareAtPrice = (this.selected_variant?.compare_at_price / 100)
				.toFixed(2)
				.replace('.', ',')
				.toString()
				.concat(' ')
				.concat(Shopify.currency.active);
		}
		return compareAtPrice;
	},

	getData(event) {
		const data = event.detail.data;
		if (!data) return;
		this.data = data;
		this.product_title = data.title;
		this.product_url = data.url;
		this.media_url = data.selected_variant.featured_media
			? data?.selected_variant?.featured_media?.src
			: data.featured_image;
		this.media_alt = data.selected_variant.featured_media
			? data?.selected_variant?.featured_media?.alt
			: data.image_alt;
		this.selected_variant = data.selected_variant;
		this.variants = data.variants;
		this.open = true;
	},

	selectVariant(id) {
		this.selected_variant = this.variants.find((variant) => variant.id === id);
		this.media_url = this.selected_variant?.featured_media
			? this.selected_variant?.featured_media?.src
			: this.data.featured_image;
		this.media_alt = this.selected_variant?.featured_media
			? this.selected_variant?.featured_media?.alt
			: this.data.image_alt;
	},

	async addVariantToCart(id) {
		const url = window.routes.cartAdd + '.js';
		const productData = {
			items: [
				{
					id: id,
					quantity: 1,
				},
			],
			sections: 'cart-main,cart-drawer-sections',
			sections_url: window.location.pathname,
		};

		const config = {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify(productData),
		};

		const response = await fetch(url, config);
		const result = await response.json();
		if (response.ok) {
			this.$dispatch('cart-update', { cartData: result });
		}
		this.open = false;
	},

	closePopup() {
		this.open = false;
	},
});
